export default function configureSymbol(symbol) {
  let finalSymbol = symbol;
  if (finalSymbol.toLocaleLowerCase().includes("undefined")) {
    finalSymbol = finalSymbol.split(":")[1];
  }
  return finalSymbol;
}
